import { CLEAR_EMBED_URL, CLEAR_RIPS_DETAIL, CLEAR_RIPS_DETAIL_BODY, CLEAR_RIPS_RESULT_BODY, EMBED_URL_ERROR, EMBED_URL_LOADING, EMBED_URL_SUCCESS, RIPS_DETAIL_ERROR, RIPS_DETAIL_HEADER, RIPS_DETAIL_LOADING, RIPS_DETAIL_SUCCESS, RIPS_RESULT_ERROR, RIPS_RESULT_LOADING, RIPS_RESULT_SUCCESS } from "./types"

export default {
    [RIPS_DETAIL_HEADER]: (state, payload) => {
        state.ripsDetail.header = payload
    },
    [CLEAR_RIPS_DETAIL]: (state) => {
        state.ripsDetail.header = {}
    },
    [RIPS_DETAIL_SUCCESS]: (state, payload) => {
        state.ripsDetail.body = payload
    },
    [RIPS_DETAIL_ERROR]: (state, payload) => {
        state.ripsDetail.errorAlert = payload
    },
    [RIPS_DETAIL_LOADING]: (state, payload) => {
        state.ripsDetail.loading = payload
    },
    [CLEAR_RIPS_DETAIL_BODY]: (state) => {
        state.ripsDetail.body = null
    },
    [RIPS_RESULT_SUCCESS]: (state, payload) => {
        state.ripsResult.body = payload
    },
    [RIPS_RESULT_ERROR]: (state, payload) => {
        state.ripsResult.errorAlert = payload
    },
    [RIPS_RESULT_LOADING]: (state, payload) => {
        state.ripsResult.loading = payload
    },
    [CLEAR_RIPS_RESULT_BODY]: (state) => {
        state.ripsResult.body.validationResults = []
    },
    [EMBED_URL_SUCCESS]: (state, payload) => {
        state.dashboardUrl.body = payload
    },
    [EMBED_URL_ERROR]: (state, payload) => {
        state.dashboardUrl.errorAlert = payload
    },
    [EMBED_URL_LOADING]: (state, payload) => {
        state.dashboardUrl.loading = payload
    },
    [CLEAR_EMBED_URL]: (state) => {
        state.dashboardUrl.body = null
    }
}